<div class="page page--scrolled">
    <div class="page__inner">
<!--        <h1 class="page__title">Tickets</h1>-->
        <div class="page__body">
            <iframe width="100%" height="100%" *ngIf="frameUrl" [src]="frameUrl" frameborder="0"></iframe>
        </div>
    </div>
</div>
